export const ONBOARDING_ROUTE_CONFIG = [
  {
    submodule: "Employee Information",
    slug: "employee-information",
    label: "Employee Information"
  },
  {
    submodule: "Current Employment",
    slug: "current-employment",
    label: "Current Employment"
  },
  {
    submodule: "Shift Mapping",
    slug: "shift-mapping",
    label: "Shift Mapping"
  },
  {
    submodule: "Previous Employment",
    slug: "previous-employment",
    label: "Previous Employment"
  },
  {
    submodule: "Education Records",
    slug: "education-records",
    label: "Education Records"
  },
  {
    submodule: "Employee Documents",
    slug: "employee-documents",
    label: "Employee Documents"
  },
  {
    submodule: "Account Details",
    slug: "account-details",
    label: "Account Details"
  },
  {
    submodule: "Emergency Info",
    slug: "emergency-info",
    label: "Emergency Info"
  },
  {
    submodule: "Assets & Access",
    slug: "assets-access",
    label: "Assets & Access"
  },
  {
    submodule: "Position History",
    slug: "position-history",
    label: "Position History"
  }
];

export const ONBOARDING_ROUTE_BY_SUBMODULE = Object.fromEntries(
  ONBOARDING_ROUTE_CONFIG.map((item) => [item.submodule, `/hrms-team/onboarding/${item.slug}`])
);

ONBOARDING_ROUTE_BY_SUBMODULE["Employee Shifts Mapping"] = ONBOARDING_ROUTE_BY_SUBMODULE["Shift Mapping"];

export const ONBOARDING_ROUTE_BY_SLUG = Object.fromEntries(
  ONBOARDING_ROUTE_CONFIG.map((item) => [item.slug, item])
);

export function getOnboardingNextRoute(slug) {
  const index = ONBOARDING_ROUTE_CONFIG.findIndex((item) => item.slug === slug);
  if (index === -1 || index === ONBOARDING_ROUTE_CONFIG.length - 1) {
    return null;
  }

  return `/hrms-team/onboarding/${ONBOARDING_ROUTE_CONFIG[index + 1].slug}`;
}

export function getOnboardingPreviousRoute(slug) {
  const index = ONBOARDING_ROUTE_CONFIG.findIndex((item) => item.slug === slug);
  if (index <= 0) {
    return "/";
  }

  return `/hrms-team/onboarding/${ONBOARDING_ROUTE_CONFIG[index - 1].slug}`;
}
